export default "__VITE_ASSET__CknvTxAz__ 288w, __VITE_ASSET__CpIXA6B6__ 432w, __VITE_ASSET__D0tGsXbz__ 576w";